import {ACTION_TYPES} from "@/store/types";

export const accountModule = {
    state: {
        isLoggedIn: false,
        account: null,
        afterLogin: null,
    },
    mutations: {
        setAccount(state, account) {
            state.isLoggedIn = Boolean(account);
            state.account = account || null;
        },
        logout(state) {
            state.isLoggedIn = false;
            state.account = null;
        },
        setAfterLogin(state, afterLogin) {
            state.afterLogin = afterLogin;
        },
    },
    actions: {
        [ACTION_TYPES.GET_ME]: {
            root: true,
            async handler({dispatch, commit}) {
                const response = await dispatch(ACTION_TYPES.CALL_API, {url: 'me/'});
                const account = response && response.body ? response.body.account : null;
                if (!account) {
                    commit('logout');
                    return response;
                }
                dispatch(ACTION_TYPES.SET_ME, account);
                return response;
            },
        },
        [ACTION_TYPES.SET_ME]: {
            root: true,
            handler({commit}, account) {
                commit('setAccount', account);
            },
        },
        [ACTION_TYPES.LOGIN]: {
            root: true,
            async handler({dispatch, commit}, params) {
                const response = await dispatch(ACTION_TYPES.CALL_API, {url: 'login/', params});
                const account = response && response.body ? response.body.account : null;
                if (!account) {
                    commit('logout');
                    return response;
                }
                dispatch(ACTION_TYPES.SET_ME, account);
                return response;
            },
        },
        [ACTION_TYPES.LOGOUT]: {
            root: true,
            async handler({commit, dispatch}) {
                try {
                    await dispatch(ACTION_TYPES.CALL_API, {url: 'logout/', params: {}, opt: {throw_error: true}});
                } catch (e) {
                    ''
                }
                commit('logout');
            }
        },
        [ACTION_TYPES.SET_AFTER_LOGIN]: {
            root: true,
            async handler({state, dispatch, commit}, params) {
                commit('setAfterLogin', params);
            }
        },
        [ACTION_TYPES.CLEAR_AFTER_LOGIN]: {
            root: true,
            async handler({state, dispatch, commit}) {
                commit('setAfterLogin', null);
            }
        },
    },
    getters: {
        account(state) {
            return state.account;
        },
        afterLogin(state) {
            return state.afterLogin;
        },
    },
};
